module.exports = __webpack_public_path__ + "img/21-SPOLVERINO-ORGOGLIO-U-COLORI-GARZA-RICAMO-SMERALDO13COPIA.6aa7ab58.jpg";